import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { CTAButton } from './CTAButton';
import { Lock, Download, ShieldCheck } from 'lucide-react';
export function PricingSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section id="pricing" className="bg-ink py-24 px-4 border-t border-white/5 relative" data-id="element-134">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-brightGreen/5 rounded-full blur-3xl pointer-events-none" data-id="element-135"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-136">
        <h2 className="font-display text-5xl md:text-6xl text-white text-center mb-12 uppercase" data-id="element-137">
          Everything. One Price.{' '}
          <span className="text-brightGreen" data-id="element-138">No Subscriptions.</span>
        </h2>

        <div className="bg-forest border-2 border-brightGreen/50 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-139">
          <div className="mb-8 border-b border-white/10 pb-8" data-id="element-140">
            <h3 className="text-xl font-bold text-white mb-6 uppercase tracking-wider text-center" data-id="element-141">
              What You're Getting Today:
            </h3>
            <ul className="space-y-3 text-gray-300 max-w-md mx-auto" data-id="element-142">
              <li className="flex justify-between items-center" data-id="element-143">
                <span data-id="element-144">Soccer Ready™ Core System</span>
                <span className="text-white font-medium" data-id="element-145">$197 value</span>
              </li>
              <li className="flex justify-between items-center text-sm" data-id="element-146">
                <span data-id="element-147">Bonus #1: Practice Builder</span>
                <span className="text-white font-medium" data-id="element-148">$27</span>
              </li>
              <li className="flex justify-between items-center text-sm" data-id="element-149">
                <span data-id="element-150">Bonus #2: Parent Management Playbook</span>
                <span className="text-white font-medium" data-id="element-151">$27</span>
              </li>
              <li className="flex justify-between items-center text-sm" data-id="element-152">
                <span data-id="element-153">Bonus #3: Fun Games Handbook</span>
                <span className="text-white font-medium" data-id="element-154">$19</span>
              </li>
              <li className="flex justify-between items-center text-sm" data-id="element-155">
                <span data-id="element-156">Bonus #4: Season Planner</span>
                <span className="text-white font-medium" data-id="element-157">$19</span>
              </li>
              <li className="flex justify-between items-center text-sm" data-id="element-158">
                <span data-id="element-159">Bonus #5: Confident Coach Blueprint</span>
                <span className="text-white font-medium" data-id="element-160">$27</span>
              </li>
              <li className="flex justify-between items-center pt-4 mt-4 border-t border-white/10 text-lg font-bold" data-id="element-161">
                <span className="text-amber uppercase" data-id="element-162">Total Value:</span>
                <span className="text-amber" data-id="element-163">$316</span>
              </li>
            </ul>
          </div>

          <div className="text-center mb-8" data-id="element-164">
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-165">
              <span className="text-3xl text-gray-500 line-through font-display" data-id="element-166">
                $316
              </span>
              <span className="text-6xl md:text-7xl font-display text-white" data-id="element-167">
                Today Only: <span className="text-brightGreen" data-id="element-168">$24</span>
              </span>
            </div>

            <div className="inline-flex flex-col items-center mt-6 bg-ink/50 py-3 px-6 rounded-lg border border-amber/20" data-id="element-169">
              <span className="text-amber text-sm font-bold uppercase tracking-wider mb-1" data-id="element-170">
                Launch pricing ends when the timer hits zero
              </span>
              <span className="font-display text-3xl text-white tracking-widest" data-id="element-171">
                {formatTime(hours)}:{formatTime(minutes)}:{formatTime(seconds)}
              </span>
            </div>
          </div>

          <div className="flex flex-col items-center" data-id="element-172">
            <CTAButton text="Yes — Give Me Instant Access to Soccer Ready™ →" href="https://soccer-ready.impultienda.ar/checkout" className="w-full md:w-auto md:px-12 py-5 text-xl md:text-2xl" data-id="element-173" />

            <div className="mt-6 flex flex-wrap justify-center items-center gap-y-2 gap-x-6 text-sm text-gray-400 font-medium" data-id="element-174">
              <div className="flex items-center gap-1.5" data-id="element-175">
                <Lock className="w-4 h-4 text-brightGreen" data-id="element-176" />
                <span data-id="element-177">Secure Checkout</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-178">
                <Download className="w-4 h-4 text-brightGreen" data-id="element-179" />
                <span data-id="element-180">Instant Digital Download</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-181">
                <ShieldCheck className="w-4 h-4 text-brightGreen" data-id="element-182" />
                <span data-id="element-183">7-Day Money-Back Guarantee</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}